function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React, { Fragment, forwardRef, useContext, useEffect, useRef, useState } from "react";
import HelperText from "../HelperText";
import Label from "../Label";
import useComposedRef from "../../hooks/useComposedRef";
import { InputFieldset } from "../InputFieldset";
import { injectTestId } from "@cvent/nucleus-test-automation";
import { resolveIds } from "../../utils";
import { useStyle } from "./Textbox.style";
import { CarinaContext } from "../CarinaProvider/index";
import { TextboxIcon } from "./components/TextboxIcon";
var Textbox = forwardRef(function(_param, ref) {
    var accessibilityLabel = _param.accessibilityLabel, containerRefProp = _param.containerRef, css = _param.css, describedBy = _param.describedBy, disabled = _param.disabled, focused = _param.focused, forwardedRef = _param.forwardedRef, hasActiveLabel = _param.hasActiveLabel, hasError = _param.hasError, helperText = _param.helperText, _hideLabel = _param.hideLabel, hideLabel = _hideLabel === void 0 ? false : _hideLabel, hideRequired = _param.hideRequired, iconEnd = _param.iconEnd, iconStart = _param.iconStart, id = _param.id, isRequired = _param.isRequired, isRtl = _param.isRtl, labelRequiredTitle = _param.labelRequiredTitle, labelText = _param.labelText, name = _param.name, onBlur = _param.onBlur, onChange = _param.onChange, onChangeText = _param.onChangeText, onFocus = _param.onFocus, placeholder = _param.placeholder, required = _param.required, size = _param.size, _style = _param.style, testID = _param.testID, value = _param.value, _variant = _param.variant, variant = _variant === void 0 ? 'default' : _variant, rest = _objectWithoutProperties(_param, [
        "accessibilityLabel",
        "containerRef",
        "css",
        "describedBy",
        "disabled",
        "focused",
        "forwardedRef",
        "hasActiveLabel",
        "hasError",
        "helperText",
        "hideLabel",
        "hideRequired",
        "iconEnd",
        "iconStart",
        "id",
        "isRequired",
        "isRtl",
        "labelRequiredTitle",
        "labelText",
        "name",
        "onBlur",
        "onChange",
        "onChangeText",
        "onFocus",
        "placeholder",
        "required",
        "size",
        "style",
        "testID",
        "value",
        "variant"
    ]);
    var internalRef = useRef(null);
    var composedRef = useComposedRef(internalRef, forwardedRef, ref);
    var internalContainerRef = useRef(null);
    var containerRef = containerRefProp !== null && containerRefProp !== void 0 ? containerRefProp : internalContainerRef;
    var isDefault = variant === 'default';
    var _$ref7 = _slicedToArray(useState(focused), 2), hasFocus = _$ref7[0], setHasFocus = _$ref7[1];
    var _$ref1 = _slicedToArray(useState(!isDefault && (!!value || !!placeholder)), 2), hasActiveLabelTransition = _$ref1[0], setHasActiveLabelTransition = _$ref1[1];
    var _$ref2;
    var _$ref3 = (_$ref2 = useContext(CarinaContext)) !== null && _$ref2 !== void 0 ? _$ref2 : {
        flags: {
            placeholderRemoval: false
        }
    }, placeholderRemoval = _$ref3.flags.placeholderRemoval;
    useEffect(function() {
        var _$ref;
        setHasActiveLabelTransition(!isDefault && (hasFocus || !!value || !!(internalRef === null || internalRef === void 0 ? void 0 : (_$ref = internalRef.current) === null || _$ref === void 0 ? void 0 : _$ref.value) || !!placeholder));
    }, [
        isDefault,
        placeholder,
        value,
        hasFocus
    ]);
    useEffect(function() {
        if ((internalRef === null || internalRef === void 0 ? void 0 : internalRef.current) && focused) {
            internalRef.current.focus();
        }
    }, [
        focused,
        internalRef
    ]);
    var _$ref4 = useStyle({
        hasError: hasError,
        hasIconEnd: !!iconEnd,
        hasIconStart: !!iconStart,
        isRequired: isRequired || required,
        isRtl: isRtl,
        size: size,
        variant: variant
    }), container = _$ref4.container, input = _$ref4.input;
    var startIcon = iconStart && _jsx(TextboxIcon, {
        icon: iconStart,
        isRtl: isRtl,
        direction: "left",
        isSmallTextbox: isDefault && size === 's',
        testID: "".concat(testID, "-start-icon"),
        variant: variant
    });
    var endIcon = iconEnd && _jsx(TextboxIcon, {
        icon: iconEnd,
        isRtl: isRtl,
        direction: "right",
        isSmallTextbox: isDefault && size === 's',
        testID: "".concat(testID, "-end-icon"),
        variant: variant
    });
    var handleChange = function(event) {
        if (onChange) {
            onChange(event);
        }
        if (onChangeText) {
            onChangeText(event.target.value);
        }
    };
    var handleFocus = function(event) {
        setHasFocus(true);
        if (onFocus) {
            onFocus(event);
        }
    };
    var handleBlur = function(event) {
        setHasFocus(false);
        if (onBlur) {
            onBlur(event);
        }
    };
    var _$ref5 = resolveIds(id, testID, 'helper-text', true), helperTextId = _$ref5.id, helperTextTestID = _$ref5.testID;
    var finalhasActiveLabel = typeof hasActiveLabel !== 'undefined' ? hasActiveLabel && !isDefault : hasActiveLabelTransition;
    var _$ref6;
    return _jsxs(Fragment, {
        children: [
            _jsxs("div", _objectSpread({
                css: container
            }, injectTestId(testID), {
                ref: containerRef,
                children: [
                    id && labelText && _jsx(Label, _objectSpread({
                        hasStartIcon: !!startIcon,
                        htmlFor: id,
                        isAnimated: finalhasActiveLabel,
                        isDisabled: disabled,
                        isHidden: variant === 'grid' || hideLabel,
                        isRequired: !hideRequired && (isRequired || required),
                        isRtl: isRtl,
                        requiredTitle: labelRequiredTitle,
                        variant: variant
                    }, resolveIds(id, testID, 'label', true), {
                        children: labelText
                    })),
                    startIcon,
                    _jsx("input", _objectSpread({}, rest, injectTestId("".concat(testID, "-input")), {
                        "aria-describedby": [
                            rest === null || rest === void 0 ? void 0 : rest['aria-describedby'],
                            describedBy,
                            id && helperText && helperTextId
                        ].filter(Boolean).join(' ') || undefined,
                        "aria-invalid": hasError,
                        "aria-label": (_$ref6 = rest['aria-label']) !== null && _$ref6 !== void 0 ? _$ref6 : accessibilityLabel,
                        css: [
                            input,
                            css
                        ],
                        disabled: disabled,
                        id: id,
                        name: name,
                        onBlur: handleBlur,
                        onChange: handleChange,
                        onFocus: handleFocus,
                        placeholder: placeholderRemoval ? undefined : placeholder,
                        ref: composedRef,
                        required: isRequired !== null && isRequired !== void 0 ? isRequired : required,
                        value: value
                    })),
                    _jsx(InputFieldset, {
                        hasActiveLabelTransition: finalhasActiveLabel,
                        hasError: hasError,
                        hideLabel: hideLabel,
                        id: id,
                        isDisabled: disabled,
                        isRequired: !hideRequired && (isRequired !== null && isRequired !== void 0 ? isRequired : required),
                        labelText: labelText,
                        size: size,
                        testID: testID,
                        variant: variant
                    }),
                    endIcon
                ]
            })),
            variant !== 'grid' && id && _jsx(HelperText, {
                id: helperTextId,
                testID: helperTextTestID,
                isRtl: isRtl,
                hasError: hasError,
                children: helperText
            })
        ]
    });
});
export { Textbox };
export default Textbox;
